import React from "react";
import "./componentsStyle.scss";
import { Button } from "antd";

export const PrimaryButton = ({ label, type, onClick }) => {
  return (
    <Button type={type} className={`${type}-button`} onClick={onClick}>
      {label}
    </Button>
  );
};
